module.exports = __webpack_public_path__ + "static/media/6.b01101fb.png";